/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: note.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CreateNoteRequest,
  CreateNoteResponse,
  ListNotesRequest,
  ListNotesResponse,
} from '../types/note';

export const createNoteService = (transport: Transport) => ({
  async createNote(
    request: CreateNoteRequest,
    options: RequestOptions = {},
  ): Promise<CreateNoteResponse> {
    const { organization_id, program_id, case_record_id, ...body } = request;
    const url = getApiPath(API_METHODS.NoteService.CreateNote, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.post<CreateNoteResponse>(url, body, options);
  },

  async listNotes(
    request: ListNotesRequest,
    options: RequestOptions = {},
  ): Promise<ListNotesResponse> {
    const { organization_id, program_id, case_record_id, ...params } = request;
    const url = getApiPath(API_METHODS.NoteService.ListNotes, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.get<ListNotesResponse>(url, { params, ...options });
  },
});

export type NoteService = ReturnType<typeof createNoteService>;
